import api from './api';

export interface PanelPermission {
  visible: boolean;
  level: 'view' | 'manage';
}

export interface MyPermissions {
  has_access: boolean;
  access_id: string | null;
  access_name: string | null;
  permissions: Record<string, PanelPermission>;
  role: string | null;
}

// Resolves the logged-in user's effective panel permissions from the TeamLio
// backend (same instance the task pages already call). `has_access=false`
// means no profile is assigned → caller should fall back to showing everything.
export const getMyPermissions = async (): Promise<MyPermissions> => {
  const res = await api.get('/access/my-permissions');
  return res.data;
};
